import FanEventsListTabComponent from "./FanEventsListTabCompnent";

export default FanEventsListTabComponent;
